import { onCLS, onINP, onLCP, onFCP, onTTFB, Metric } from 'web-vitals';

type Endpoint = (m: Metric) => void;

export const reportWebVitals = (send: Endpoint) => {
  onCLS(send);
  onINP(send);
  onLCP(send);
  onFCP(send);
  onTTFB(send);
};
